import React from 'react';

interface UserIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
}

const UserIcon: React.FC<UserIconProps> = ({
  size = 34,
  color = '#27788C',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.4277 17.9981L22.994 19.047C25.1458 19.5085 25.6748 22.257 26.0062 25.9249M14.1968 17.9981L10.6306 19.047C8.47875 19.5085 7.9497 22.257 7.61903 25.9249M17 1.49609C20.1645 1.49609 23.2579 2.4345 25.8891 4.1926C28.5203 5.9507 30.5711 8.44956 31.7821 11.3732C32.9931 14.2968 33.3099 17.5139 32.6926 20.6175C32.0752 23.7212 30.5514 26.5722 28.3137 28.8098C26.0761 31.0474 23.2251 32.5713 20.1214 33.1887C17.0177 33.806 13.8007 33.4892 10.8771 32.2782C7.95344 31.0671 5.45459 29.0164 3.69648 26.3852C1.93838 23.754 1 20.6606 1 17.4961C1 13.2526 2.6857 9.18298 5.68628 6.1824C8.68687 3.18182 12.7565 1.49609 17 1.49609ZM16.8101 18.471C15.7834 18.471 14.7798 18.1666 13.9261 17.5962C13.0724 17.0258 12.4071 16.215 12.0142 15.2665C11.6213 14.3179 11.5185 13.2742 11.7188 12.2672C11.9191 11.2602 12.4135 10.3352 13.1395 9.60924C13.8655 8.88325 14.7904 8.38886 15.7974 8.18856C16.8044 7.98826 17.8481 8.09106 18.7967 8.48396C19.7452 8.87686 20.556 9.54222 21.1264 10.3959C21.6968 11.2496 22.0012 12.2532 22.0012 13.2799C22.0012 14.6567 21.4543 15.9771 20.4808 16.9506C19.5073 17.9241 18.1869 18.471 16.8101 18.471Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default UserIcon;
